import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

let webApiUrl = `${process.env.REACT_APP_BASE_URL}air_hourly/`;
let tokenStr = process.env.REACT_APP_API_TOKEN;

export const fetchStationsHourly = createAsyncThunk(
  "stations/fetchStationsHourly",
  () => {
    return axios
      .get(webApiUrl, { headers: { Authorization: `Token ${tokenStr}` } })
      .then((response) => response.data);
  }
);
const stationsSlice = createSlice({
  name: "stationsHourly",
  initialState: {
    stationsLoading: true,
    stationsData: {
      SATA2: [],
    },
    stationsError: "",
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchStationsHourly.pending,
      (state) => {
        state.stationsLoading = true;
      },
      builder.addCase(
        fetchStationsHourly.fulfilled,
        (state, action) => {
          state.stationsLoading = false;
          state.stationsData = action.payload;
          state.stationsError = "";
        },
        builder.addCase(fetchStationsHourly.rejected, (state, action) => {
          state.stationsLoading = false;
          state.stationsData = [];
          state.stationsError = action.error.message;
        })
      )
    );
  },
});
export default stationsSlice.reducer;
